module.exports = __webpack_public_path__ + "static/media/telefone.5fdb79f9.svg";